import React from "react";
import { NavBar } from 'antd-mobile'

import { 
    BodyView
} from "../../factory/ViewUtil";
import { LogoIcon } from "../../icons";


const MeAboutViewController = ({goback}) => {
    const appVersion = '1.1.0'
    const appName = 'Enxbit';
    return(
        <>
             <div className='fixed-nav-bar'>
                <NavBar onBack = {goback}></NavBar>
            </div>
            <BodyView style={{paddingTop : '52px', textAlign : 'center'}}>
                <div style={{marginTop : '100px'}}><LogoIcon/></div>
                <div style={{fontSize : '20px', fontWeight : 'bold', padding : '10px 0'}}>Crypto {appName}</div>
                <div style={{fontSize : '12px'}}>Version {appVersion}</div>
                <div style={{
                    position : 'fixed',
                    bottom : '20px',
                    textAlign : 'center',
                    fontSize : '12px',
                    width : '100%',
                    color : '#999'
                }}> Copyright @ {appName}. All Rights Reserved</div>
            </BodyView>
        </>
    );
}
export default React.memo(MeAboutViewController)